module.exports = __webpack_public_path__ + "img/no_wifi.062bf916.svg";